export default __webpack_public_path__ + "static/ADLogo-74b06d14ae4fbb1129cebf62d4ca4307.jpg";